module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-MediumItalic.a4544d03.otf";